import module from '../module';
import {utils} from "../../../utils/shopifyInjector/utils";

class AuthInterceptorService {
    static $inject = ['Session', '$rootScope', '$q', 'cartonomyConfig'];

    constructor(session, rootScope, qService, cartonomyConfig) {

        this._session = session;
        this._rootScope = rootScope;
        this._qService = qService;
        this._cartonomyConfig = cartonomyConfig;

        // these calls are required as these methods will be used directly
        this.request = (config) => this._request(config);
        this.responseError = (response) => this._responseError(response);
    }

    _request(config) {
        config.headers = config.headers || {};

        if (config.method === "GET" && /\.(html|svg|png|gif|jpg|css|js)$/.test(config.url)) {
            // these file types should be downloaded as static files, no authorization or other adjustments
            return config;
        }

        if (this._cartonomyConfig.externalStoreMode && this._cartonomyConfig.externalStoreUrl) {
            config.headers.X_EXTERNAL_STORE = this._cartonomyConfig.externalStoreUrl;
        }

        return this._session.getAuthToken().then(authToken => {
            if (!authToken) {
                return config;
            }

            config.headers.Authorization = 'Bearer ' + authToken;
            return config;
        });
    }

    async _responseError(response) {
        if (response.status === 401) {
            await this._session.clearSessionDetails();
            this._session.setCachedUser(null);
            this._session.setCartReference(null, false);
        }
        return this._qService.reject(response);
    }
}

module
    .service('AuthInterceptor', AuthInterceptorService)
    .config(['$httpProvider',
        function ($httpProvider) {
            $httpProvider.interceptors.push('AuthInterceptor');
        }]
    );



// WEBPACK FOOTER //
// ./src/modules/shared/services/AuthInterceptorService.js